import api from "../axios_service";

export async function listaDeCompras(filtros) {
  const response = await api.get(
    `/relatorios/compras${filtros ? filtros : ""}`
  );
  return response.data.result;
}